import React from 'react';
import { ArrayHelpers, Loading, Paging } from 'e4shared';
import BlobImage from 'components/blobImage';
import Toggle from 'components/prism/toggle';

export const Leaderboard = ({ text, data, period, setPeriod, loading }) => {
    const pageSize = 10;
    const [page, setPage] = React.useState(1);

    return (
        <div>
            <div className="two-col flex flex-center mb10">
                <h2 className="flex-grow mr20">{text.title}</h2>
                <div className="text-right">
                    <Toggle value={period} onChange={setPeriod}>
                        <button value="M">{text.month}</button>
                        <button value="Q">{text.quarter}</button>
                        <button value="Y">{text.year}</button>
                        <button value="">{text.allTime}</button>
                    </Toggle>
                </div>
            </div>
            <div className="prism-content-box">
                {loading ? (
                    <Loading />
                ) : (
                    <div className="prism-content-hover">
                        {ArrayHelpers.getPage(data, page, pageSize).map((item, i) => {
                            return (
                                <div key={`item-${item.id}`} className="flex flex-center">
                                    <div className="mr10 text-right" style={{ width: '20px' }}>
                                        {(page - 1) * pageSize + 1 + i}.
                                    </div>
                                    <BlobImage
                                        folder="avatar"
                                        src={item.avatar}
                                        width="25"
                                        height="25"
                                        initials={item.initials}
                                        className="img-circle"
                                    />
                                    <div className="ml10">{item.full_Name}</div>
                                    <div className="flex-grow text-right">{item.value}</div>
                                </div>
                            );
                        })}
                    </div>
                )}
            </div>
            {!loading && data.length > pageSize && (
                <div className="mt10 text-center welcome-paging">
                    <Paging recordCount={data.length} page={page} pageSize={pageSize} goToPage={setPage} />
                </div>
            )}
        </div>
    );
};

export default Leaderboard;
